import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Página no encontrada" />
      <div className="max-w-2xl mx-auto px-6 py-32 text-center">
        <p className="font-serif text-7xl text-[#1f44e0]">404</p>
        <h1 className="font-serif text-3xl text-[#0f2544] mt-4">Página no encontrada</h1>
        <p className="text-[#4a4a45] mt-3">La página que buscas no existe o ha sido movida.</p>
        <Link to="/" className="inline-block mt-8 rounded-full bg-[#0f2544] px-7 py-3 text-xs font-semibold tracking-[0.12em] text-white hover:bg-[#1f44e0] transition-colors">
          VOLVER AL INICIO
        </Link>
      </div>
    </>
  );
}
